import { ExpectedError } from "./expectedError";

export const PERSONAL_WORK_DISABLED_MESSAGE =
  "Personal work is disabled for this tenant";

export class PersonalWorkDisabledError extends ExpectedError {
  constructor() {
    super(PERSONAL_WORK_DISABLED_MESSAGE);
    this.name = "PersonalWorkDisabledError";
  }
}

export function isPersonalWorkEnabled(tenant: {
  personalWorkDisabledAt: number | null | undefined;
}): boolean {
  return tenant.personalWorkDisabledAt == null;
}
